import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { FULL_API_BASE_URL } from "../../Config/Config";

export const fetchBloodGroupData = createAsyncThunk(
  "api/bloodgroup",
  async () => {
    const response = await fetch(`${FULL_API_BASE_URL}/get-blood-group/`);
    const data = await response.json();
    return data;
  }
);

const bloodgroupSlice = createSlice({
  name: "bloodGroup",
  initialState: {
    bloodgroupdata: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBloodGroupData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBloodGroupData.fulfilled, (state, action) => {
        state.loading = false;
        state.bloodgroupdata = action.payload;
      })
      .addCase(fetchBloodGroupData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default bloodgroupSlice.reducer;
